/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { ERC1155Holder } from "../ERC1155Holder";

export class ERC1155Holder__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<ERC1155Holder> {
    return super.deploy(overrides || {}) as Promise<ERC1155Holder>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ERC1155Holder {
    return super.attach(address) as ERC1155Holder;
  }
  connect(signer: Signer): ERC1155Holder__factory {
    return super.connect(signer) as ERC1155Holder__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC1155Holder {
    return new Contract(address, _abi, signerOrProvider) as ERC1155Holder;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b506104f1806100206000396000f3fe608060405234801561001057600080fd5b50600436106100415760003560e01c806301ffc9a714610046578063bc197c811461006e578063f23a6e61146100d7575b600080fd5b6100596100543660046103f4565b61010f565b60405190151581526020015b60405180910390f35b6100a661007c3660046102e5565b7fbc197c810000000000000000000000000000000000000000000000000000000095945050505050565b6040517fffffffff000000000000000000000000000000000000000000000000000000009091168152602001610065565b6100a66100e536600461038f565b7ff23a6e610000000000000000000000000000000000000000000000000000000095945050505050565b60007fffffffff0000000000000000000000000000000000000000000000000000000082167f4e2312e00000000000000000000000000000000000000000000000000000000014806101a257507f01ffc9a7000000000000000000000000000000000000000000000000000000007fffffffff000000000000000000000000000000000000000000000000000000008316145b92915050565b803573ffffffffffffffffffffffffffffffffffffffff811681146101cc57600080fd5b919050565b600082601f8301126101e257600080fd5b8135602067ffffffffffffffff8211156101fe576101fe61048c565b8160051b61020d82820161043d565b83815282810190868401838801850189101561022857600080fd5b600093505b8584101561024b57803583526001939093019291840191840161022d565b50979650505050505050565b600082601f83011261026857600080fd5b813567ffffffffffffffff8111156102825761028261048c565b6102b360207fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0601f8401160161043d565b8181528460208386010111156102c857600080fd5b816020850160208301376000918101602001919091529392505050565b600080600080600060a086880312156102fd57600080fd5b610306866101a8565b9450610314602087016101a8565b9350604086013567ffffffffffffffff8082111561033157600080fd5b61033d89838a016101d1565b9450606088013591508082111561035357600080fd5b61035f89838a016101d1565b9350608088013591508082111561037557600080fd5b5061038288828901610257565b9150509295509295909350565b600080600080600060a086880312156103a757600080fd5b6103b0866101a8565b94506103be602087016101a8565b93506040860135925060608601359150608086013567ffffffffffffffff8111156103e857600080fd5b61038288828901610257565b60006020828403121561040657600080fd5b81357fffffffff000000000000000000000000000000000000000000000000000000008116811461043657600080fd5b9392505050565b604051601f82017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe016810167ffffffffffffffff811182821017156104845761048461048c565b604052919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fdfea2646970667358221220d0800551488688136c77538a73509154680444dfce591ab146d3574ec830cf3964736f6c63430008070033";
